import { RTable } from "../../Component/Table/RTable";
import { TableStructure } from "../../Component/Table/TableStructureInterface";
import { PageHeader } from "../../Component/Common/Headers";
import { dateFormat } from "../../Helpers/commonFunction/commonFunction";
import { Link } from "react-router-dom";
import { PUBLIC_URL } from "../../Helpers/config/config";

export const LeadList = () => {
  const tableStructure: TableStructure[] = [
    {
      name: "id",
      render: (data: any, index: any) => {
        return index;
      },
    },
    {
      name: "Full Name",
      key: "fullname",
      render: (data: any) => {
        return data.fullname || "-";
      },
    },
    {
      name: "Mobile Number",
      key: "mobilenumber",
      render: (data: any) => {
        return data.mobilenumber || "-";
      },
    },
    {
      name: "Email",
      key: "email",
      render: (data: any) => {
        return data.email || "-";
      },
    },
    {
      name: "University",
      key: "universityName",
      render: (data: any) => {
        return data.universityName || data.university || "-";
      },
    },
    {
      name: "Program",
      key: "program",
      render: (data: any) => {
        return data.program || "-";
      },
    },
    {
      name: "State",
      key: "state",
      render: (data: any) => {
        return data.state || "-";
      },
    },
    {
      name: "Source",
      key: "utmSource",
      render: (data: any) => {
        return data.utmSource || "-";
      },
    },
    {
      name: "Medium",
      key: "utmMedium",
      render: (data: any) => {
        return data.utmMedium || "-";
      },
    },
    {
      name: "Campaign",
      key: "utmCampaign",
      render: (data: any) => {
        return data.utmCampaign || "-";
      },
    },
    {
      name: "Term",
      key: "utmTerm",
      render: (data: any) => {
        return data.utmTerm || "-";
      },
    },
    {
      name: "Content",
      key: "utmContent",
      render: (data: any) => {
        return data.utmContent || "-";
      },
    },
    {
      name: "Action Tag",
      key: "utmAction",
      render: (data: any) => {
        return data.utmAction || "-";
      },
    },
    {
      name: "Page URL",
      key: "url",
      render: (data: any) => {
        if (!data.url) return "-";
        return (
          <span
            title={data.url}
            style={{
              maxWidth: "180px",
              display: "inline-block",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {data.url}
          </span>
        );
      },
    },
    {
      name: "IP Address",
      key: "ip",
      render: (data: any) => {
        return data.ip || "-";
      },
    },
    {
      name: "Created At",
      key: "createdAt",
      render: (data: any) => {
        return data.createdAt ? dateFormat(data.createdAt) : "-";
      },
    },
    {
      name: "Updated At",
      key: "updatedAt",
      render: (data: any) => {
        return data.updatedAt ? dateFormat(data.updatedAt) : "-";
      },
    },
    {
      name: "Action",
      render: (data: any, onDelete: any) => {
        return (
          <div className="d-flex align-items-center justify-content-start gap-3">
            <Link
              to="#"
              onClick={(e) => {
                e.preventDefault();
                onDelete(data.id);
              }}
              title="Delete Lead"
            >
              <img width="16px" src={PUBLIC_URL + "/images/delete.svg"} alt="delete" />
            </Link>
          </div>
        );
      },
    },
  ];

  return (
    <div className="container-fluid px-4">
      <PageHeader
        title="Lead Management"
        subtitle="View and manage all captured leads with complete campaign, tracking, and source attribution"
      />
      <RTable
        xFileName="leads_data"
        deleteUrl="leads"
        api="leads/withPagination"
        tableStructure={tableStructure}
      />
    </div>
  );
};

